export const cfMarketingLookupTable = {
  cf_company: 'cf_signup_company_name',
  cf_cf_marketingcampaign: 'cf_marketing_campaign',
  cf_cf_campaigndate: 'cf_campaign_date',
  cf_cf_leadspaceindustry: 'cf_ls_company_industry',
  cf_cf_leadspacecompanysizerange: 'cf_ls_company_size_range',
  cf_cf_leadspaceducompanycountry: 'cf_ls_du_company_country',
  cf_cf_subproduct: 'cf_sub_product',
  cf_cf_leadspacedulsid: 'cf_du_ls_id',
  cf_cf_industry: 'cf_industry_type',
  cf_cf_leadspaceducompanyzipcode: 'cf_ls_du_company_zipcode',
  cf_cf_region: 'cf_region',
  cf_cf_numberofemployees: 'cf_number_of_employees',
  cf_cf_crmdapstatus: 'cf_dap_status',
  cf_cf_leadspaceducompanystate: 'cf_ls_du_company_state',
  cf_cf_leadspacepersonphoneno: 'cf_ls_person_phone',
  cf_cf_mqlcreateddate: 'cf_mql_date',
  cf_cf_leadspacecompanyname: 'cf_ls_du_company_name',
  cf_cf_leadspacegucompanyname: 'cf_ls_gu_company_name',
  cf_cf_tacticid: 'cf_allocadia_tactic_id',
  cf_cf_leadspacesubindustry: 'cf_ls_company_sub_industry',
  cf_cf_leadspacepersonjobtitle: 'cf_ls_person_title',
  cf_cf_leadspacescore: 'cf_leadspace_score',
  cf_cf_fweudemofocus: 'cf_enriched_mm_score',
  cf_cf_emailvalidationstatus: 'cf_zerobounce_status',
  cf_cf_product: 'cf_product',
  cf_cf_engagementstatus: 'cf_engagement_status',
  cf_cf_subscriptionstatus: 'cf_hallway_lead_type',
  cf_cf_joblevel: 'cf_job_level'
};
